import { motion } from "framer-motion";
import { FadeIn, StaggeredGrid } from "@/components/animated";
import { howItWorksSteps } from "@/data/homePageData";
import { UserPlus, Search, GraduationCap, ArrowRight } from "lucide-react";

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  UserPlus: UserPlus,
  Search: Search,
  GraduationCap: GraduationCap,
};

export function HowItWorksSection() {
  return (
    <section className="py-20 bg-primary-950 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary-900/50 rounded-full blur-3xl" />
      </div>

      <div className="container relative z-10">
        <FadeIn>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 bg-white/10 text-primary-200 text-sm font-medium rounded-full mb-4">
              Simple y efectivo
            </span>
            <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">
              Cómo funciona
            </h2>
            <p className="text-primary-200 max-w-2xl mx-auto">
              Empieza tu viaje de aprendizaje en solo 3 pasos
            </p>
          </div>
        </FadeIn>

        <StaggeredGrid
          className="grid md:grid-cols-3 gap-8 lg:gap-12"
          staggerDelay={0.15}
        >
          {howItWorksSteps.map((step, index) => {
            const Icon = iconMap[step.icon] || UserPlus;
            const isLast = index === howItWorksSteps.length - 1;

            return (
              <div key={step.id} className="relative">
                {/* Connector line for desktop */}
                {!isLast && (
                  <div className="hidden md:block absolute top-12 left-[60%] w-[80%] h-px bg-gradient-to-r from-primary-500/50 to-transparent" />
                )}

                <motion.div
                  whileHover={{ y: -4 }}
                  className="text-center relative"
                >
                  {/* Step number */}
                  <div className="inline-flex items-center justify-center w-24 h-24 rounded-3xl bg-gradient-to-br from-primary-500 to-primary-700 mb-6 shadow-lg shadow-primary-500/25 relative">
                    <Icon className="h-10 w-10 text-white" />
                    <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gold-400 text-primary-950 font-bold flex items-center justify-center text-sm">
                      {step.step}
                    </span>
                  </div>

                  <h3 className="text-xl font-semibold mb-3">{step.title}</h3>
                  <p className="text-primary-200 leading-relaxed">
                    {step.description}
                  </p>
                </motion.div>
              </div>
            );
          })}
        </StaggeredGrid>

        <FadeIn delay={0.4}>
          <div className="text-center mt-12">
            <motion.a
              href="/register"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              className="inline-flex items-center gap-2 px-8 py-4 bg-white text-primary-900 font-semibold rounded-xl hover:bg-primary-50 transition-colors shadow-lg"
            >
              Comenzar ahora - Es gratis
              <ArrowRight className="h-5 w-5" />
            </motion.a>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
